class MediaBrands extends HTMLElement {
  constructor() {
    super();
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.addEventListener('change', (event) => {
      if (event.target.classList.contains('media-brand-input')) {
        this.updateMedias(event.target.value);
      }
    });
  }

  updateMedias(value) {
    console.log('updateMedias(value): ', value);
    const activeSection = document.querySelector('.media-section.active');
    const targetSection = document.querySelector(`.media-section[data-medias-type="${value}"]`);

    if (activeSection && activeSection.dataset.mediasType !== value) {
      console.log('has activeSection');
      fadeOut(activeSection, 150, () => {
        activeSection.classList.remove('active');
        if (targetSection) {
          console.log('has targetSection');
          fadeIn(targetSection, 150, () => {
            targetSection.classList.add('active');
            this.scrollToIfNotVisible(targetSection);
            
          });
          
        }
      });
    } else {
      console.log('no activeSection. looking for: .media-section[data-medias-type="', value, '"]');
      if (targetSection) {
        console.log('has targetSection');
        fadeIn(targetSection, 150, () => {
          targetSection.classList.add('active');
          this.scrollToIfNotVisible(targetSection);
        });

      } else {
        console.log('no targetSection');
      }
    }
  }

  scrollToIfNotVisible(element) {
    const rect = element.getBoundingClientRect();
    const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

    if (!isVisible) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}

}

customElements.define('media-brands', MediaBrands);
